import React from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import configData from "../../config/config.json";
import BackButton from "../common/BackButton";
import Loading from "../common/modal/Loading";
import { LOADING_STATUES } from "../constants/constants";

export default function ConfirmAlertEmailSmall({ match, history }) {
  const ticket = match.params.ticket;
  const isNarrowScreen = window.innerWidth <= 360;
  const countyName = useSelector((state) => state.countyConfigCommonReducer.countyName);
  const appTitle = useSelector((state) => state.countyConfigCommonReducer.appTitle);

  const [pageHeading, setPageHeading] = React.useState("");
  const [completeMessage, setCompleteMessage] = React.useState("");
  const [loadingStatus, setLoadingStatus] = React.useState(LOADING_STATUES.LOADING);

  React.useEffect(() => {
    axios.post(configData.LANDNOTIFICATION_SERVER_URL + "auth/confirmAlertEmail", { ticket }, { withCredentials: true })
      .then(() => {
        setPageHeading("Email Verification Complete");
        setLoadingStatus("");
        setCompleteMessage("You're all set.  We will email you when there is a match on your alert criteria.");
      }, (error) => {
        setPageHeading("Unable to verify email");
        setLoadingStatus("");
        setCompleteMessage(error.response.data.message);
      });
  }, [ticket]);

  const handleSubmit = (event) => {
    event.preventDefault();
    history.push("/loginMobile");
  };

  return (
    <div>
      {/* Banner */}
      <div style={styles.banner}>
        <div style={styles.logoContainer}>
          <BackButton onClick={() => history.push("/loginMobile")} ariaLabel="Back to login" />
        </div>

        <div style={styles.titleContainer}>
          <div
            style={{
              ...styles.title,
              fontSize: isNarrowScreen ? "16px" : "20px",
            }}
          >
            {countyName}
          </div>
          <div
            style={{
              ...styles.subtitle,
              fontSize: isNarrowScreen ? "13px" : "16px",
            }}
          >
            {appTitle}
          </div>
        </div>

        <div style={styles.right} />
      </div>

      {/* Content */}
      <div style={styles.content}>
        <h2
          style={{
            ...styles.pageTitle,
            fontSize: isNarrowScreen ? "18px" : "20px",
          }}
        >
          {pageHeading}
        </h2>

        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.message}>{completeMessage}</div>

          <button type="submit" style={styles.submitButton}>
            Continue
          </button>
        </form>
      </div>

      <Loading loadingIndicator={loadingStatus === LOADING_STATUES.LOADING} />
    </div>
  );
}

const styles = {
  banner: {
    display: "grid",
    gridTemplateColumns: "auto 1fr auto",
    alignItems: "center",
    backgroundColor: "#114E6B",
    color: "white",
    padding: "14px 16px",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    boxSizing: "border-box",
    overflowX: "hidden",
    zIndex: 1000,
  },

  logoContainer: {
    width: "40px",
    height: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  titleContainer: {
    marginLeft: "8px",
    textAlign: "left",
  },

  title: {
    fontWeight: "700",
    fontSize: "20px",
    lineHeight: "1.2",
    color: "white",
  },

  subtitle: {
    fontSize: "16px",
    letterSpacing: "0.5px",
    opacity: 0.9,
    color: "white",
  },

  right: {
    justifySelf: "end",
    width: "40px",
  },

  content: {
    marginTop: "70px",
    padding: "16px",
  },

  pageTitle: {
    marginBottom: "20px",
    color: "#114E6B",
  },

  form: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },

  message: {
    fontSize: "14px",
    color: "#444",
    lineHeight: "1.5",
  },

  submitButton: {
    backgroundColor: "#114E6B",
    color: "white",
    padding: "10px",
    borderRadius: "6px",
    border: "none",
    fontWeight: "bold",
    cursor: "pointer",
  },
};
